module.exports = __webpack_public_path__ + "img/fog.a5b88194.png";